module.exports = __webpack_public_path__ + "static/media/pigments2.bbf45032.JPG";